import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import Investigations from "@/components/Investigations";
import Investigation from "@/components/Investigation";
import Exhibitions from "@/components/Exhibitions";
import Exhibition from "@/components/Exhibition";
import Events from "@/components/Events";
import Publications from "@/components/Publications";
import Publication from "@/components/Publication";
import News from "@/components/News";
import Resources from "@/components/Resources";
import Slideshow from "@/components/Slideshow";
import Subdomain from "@/components/Subdomain";
import Page from "@/components/Page";
import Team from "@/components/Team";
import TeamDetail from "@/components/TeamDetail";
import Auth from "@/components/Auth";
import Donate from "@/components/Donate";
import Maintenance from "@/components/Maintenance";
import PageNotFound from "@/components/PageNotFound";
import store from "../store";
// import redirects from './redirects'

// console.log(redirects)

Vue.use(Router);
Vue.use(Meta, {
  refreshOnceOnNavigation: true,
});

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Investigations",
      components: {
        default: Investigations,
      },
      meta: {
        logo: true,
        pipLower: true,
        subMenu: "Investigations",
      },
      children: [
        {
          name: "Investigation Category",
          path: "category/:slug",
          components: {
            default: Investigations,
          },
          meta: {
            logo: true,
            pipLower: true,
            subMenu: "Investigations",
            infoBox: true,
            infoBoxType: "area",
            title: false,
          },
        },
        {
          name: "Investigation Location",
          path: "location/:slug",
          components: {
            default: Investigations,
          },
          meta: {
            logo: true,
            pipLower: true,
            subMenu: "Investigations",
            title: false,
          },
        },
        {
          name: "Investigation Methodology",
          path: "methodology/:slug",
          components: {
            default: Investigations,
          },
          meta: {
            logo: true,
            pipLower: true,
            subMenu: "Investigations",
            infoBox: true,
            infoBoxType: "methodology",
            title: false,
          },
          beforeEnter: (to, from, next) => {
            store.dispatch("getMethodologies");
            next();
          },
        },
        {
          name: "Studies",
          path: "studies",
          components: {
            default: Investigations,
          },
          meta: {
            logo: true,
            pipLower: true,
            subMenu: "Investigations",
            title: false,
          },
        },
      ],
    },
    {
      path: "/investigation/:investigationSlug/:resources?/:resource?",
      name: "Investigation",
      components: {
        default: Investigation,
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getInvestigations").then(() => {
          store.dispatch("getInvestigation", to).then(() => {
            // store.commit('UPDATE_PAGE_TITLE', store.getters.getInvestigationBySlug(to.params.investigationSlug).title)
            next();
          });
        });
      },
    },
    {
      path: "/map",
      name: "Map",
      component: () => import(/* webpackChunkName: "Map" */ "@/components/Map"),
      meta: {
        logo: true,
        pipLower: true,
        subMenu: "Investigations",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getMapLocations").then(() => {
          next();
        });
      },
    },
    {
      path: "/subdomain/:subdomain",
      name: "Subdomain",
      components: {
        default: Subdomain,
      },
      meta: {
        subMenu: "Subdomain",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getSubdomains").then(() => {
          store.dispatch("getExhibitions").then(() => {
            next();
          });
        });
      },
    },
    {
      path: "/programme/exhibitions",
      name: "Exhibitions",
      components: {
        default: Exhibitions,
      },
      meta: {
        subMenu: "Programme",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getExhibitions").then(() => {
          store.dispatch("getEvents").then(() => {
            next();
          });
        });
      },
    },
    {
      path: "/programme/exhibitions/:slug",
      name: "Exhibition",
      components: {
        default: Exhibition,
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getExhibitions").then(() => {
          store.dispatch("getExhibition", to).then(() => next());
        });
      },
      children: [
        {
          name: "Exhibition Resources",
          path: "resources",
          components: {
            resources: Resources,
          },
          meta: {
            dark: true,
            panel: true,
          },
        },
        {
          name: "Exhibition Gallery",
          path: "gallery/:index",
          components: {
            gallery: Slideshow,
          },
          meta: {
            panel: true,
          },
        },
      ],
    },
    {
      path: "/programme/events/:slug?",
      name: "Events",
      components: {
        default: Events,
      },
      meta: {
        pipLower: true,
        subMenu: "Programme",
        showMenuBorder: true,
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getEvents").then(() => {
          next();
        });
      },
    },
    {
      path: "/programme/news/:slug?",
      name: "News",
      components: {
        default: News,
      },
      meta: {
        pipLower: true,
        showMenuBorder: true,
        subMenu: "Programme",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getNews").then(() => {
          next();
        });
      },
    },
    {
      path: "/programme/publications/:slug",
      name: "Publication",
      components: {
        default: Publication,
      },
      meta: {
        pipLower: true,
        subMenu: "Programme",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getPublications").then(() => {
          next();
        });
      },
    },
    {
      path: "/programme/publications",
      name: "Publications",
      components: {
        default: Publications,
      },
      meta: {
        pipLower: true,
        subMenu: "Programme",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getPublications").then(() => {
          next();
        });
      },
    },
    {
      path: "/programme/:page?",
      name: "Programme",
      components: {
        default: Page,
      },
      meta: {
        pipLower: true,
        subMenu: "Programme",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getPage", to.params.page).then(() => {
          next();
        });
      },
    },
    {
      path: "/about/team/member/:slug",
      name: "Team Member",
      component: TeamDetail,
      meta: {
        pipLower: true,
        subMenu: "About",
      },
    },
    {
      path: "/about/team",
      name: "Team",
      component: Team,
      meta: {
        pipLower: true,
        subMenu: "About",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getPage", "team").then(() => {
          store.commit("UPDATE_PAGE_TITLE", "Team");
          next();
        });
      },
    },
    {
      path: "/about/:page?",
      name: "About",
      components: {
        default: Page,
      },
      meta: {
        pipLower: true,
        subMenu: "About",
      },
      beforeEnter: (to, from, next) => {
        store.dispatch("getPage", to.params.page).then(() => {
          next();
        });
      },
    },
    {
      path: "/donate",
      name: "Donate",
      component: Donate,
    },
    {
      path: "/maintenance",
      name: "Maintenance",
      component: Maintenance,
    },
    {
      path: "/auth",
      name: "Auth",
      component: Auth,
    },
    {
      path: "/page-not-found/:brokenLink?",
      name: "Not Found",
      component: PageNotFound,
    },
    {
      path: "*",
      redirect: (to) => {
        return {
          name: "Not Found",
          params: { brokenLink: to.path.substr(1) },
        };
      },
    },
  ],
  scrollBehavior(to, from) {
    return { x: 0, y: 0 };
  },
});

//
// GUARDS
//
router.beforeEach((to, from, next) => {
  window.from = from;
  // window._paq.push(["setCustomUrl", to.fullPath]);
  // window._paq.push(["trackPageView"]);

  if (!["Auth", "Maintenance"].includes(to.name)) {
    store.dispatch("getInvestigations").then(() => {
      store.dispatch("getExhibitions").then(() => {
        store.dispatch("getSubdomains");
        next();
        setTimeout(function () {
          window.prerenderReady = true;
          console.log("ready");
        }, 1500);
      });
    });
  } else {
    next();
  }
});

export default router;
